import Layout from "@/views/Layout.vue";

const router = [
  {
    path: "/job-info", //招聘信息
    name: "job-info",
    component: () => import("@/views/job-info/Index.vue"),
  },
];
const routerItem = {
  path: "/",
  redirect: "/job-info",
  component: Layout,
  children: router,
};

export default routerItem;
